function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-38.9%",
  y: "-375.7%",
  width: "177.7%",
  height: "851.3%",
  filterUnits: "objectBoundingBox",
  id: "taken_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "3.75669643 0",
  in: "SourceGraphic"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-471-247H969V823H-471z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 3h70v60H1z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 38.09l2.063 3.02H9.62c2.445 0 5.012-1.006 7.7-3.02L14.41 36c-3.121 1.394-5.318 2.09-6.592 2.09H0z",
  stroke: "#844C22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.195 42.428c-.797.135-1.195.327-1.195.579 0 .376 3.61.362 6.83.362s22.17.615 22.17.615c0 .158-4.407-.837-13.22-2.984L7.195 42.428z",
  fill: "#D8D8D8",
  filter: "url(#taken_svg__a)"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#844C22",
  fill: "#E44646",
  x: 10.5,
  y: 37.5,
  width: 25,
  height: 5,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 27.005l4.956-3.485c3.462-.693 6.522-.693 9.177 0a43.079 43.079 0 017.7 2.815l-3.622 3.335c-1.733-1.133-4.135-2.021-7.205-2.665-3.07-.643-6.74-.643-11.006 0z",
  stroke: "#844C22",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 36.423V27.45m0-2.89V2.5v22.06z",
  stroke: "#844C22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 19.005l4.956-3.485c3.462-.693 6.522-.693 9.177 0a43.079 43.079 0 017.7 2.815l-3.622 3.335c-1.733-1.133-4.135-2.021-7.205-2.665-3.07-.643-6.74-.643-11.006 0z",
  stroke: "#844C22",
  fill: "#EDB46D",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.28 42.27l-2.744 4.1H34.74c-2.444 0-5.358-1.093-8.741-3.28l3.622-3.5c3.26 1.786 5.526 2.68 6.8 2.68h8.859zM11 16.005l4.956-3.485c3.462-.693 6.522-.693 9.177 0a43.079 43.079 0 017.7 2.815l-3.622 3.335c-1.733-1.133-4.135-2.021-7.205-2.665-3.07-.643-6.74-.643-11.006 0z",
  stroke: "#844C22",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#844C22",
  fill: "#E44646",
  x: 13.5,
  y: 32.5,
  width: 19,
  height: 5,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 13.5v-11",
  stroke: "#844C22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#844C22",
  fill: "#E44646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M20.728 9H25L22.864.05z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 38.5h21",
  stroke: "#FFF",
  opacity: 0.528,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5 5.5L22 7.965",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 33.5h15",
  stroke: "#FFF",
  opacity: 0.528,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.75 45.811l1.907-3.119c-1.203-.27-2.18-.597-2.932-.983-.733-.356-1.74-.852-3.02-1.487l-2.895 2.773c1.773 1.09 3.298 1.842 4.574 2.257.6.194 1.389.38 2.366.56z",
  fill: "#D8D8D8",
  opacity: 0.451
})));

function SvgTaken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTaken;